export function pasteCopiedTasks({ store, id }) {
    const copied = store.getState().copiedTasksId;
    id = id || copied.at(-1);
    store.in.exec("paste-task", {
        targetId: id,
        parent: store.getTask(id)?.parent ?? null,
    });
}
//# sourceMappingURL=paste.js.map